import React from 'react';

import { ToggleGroup, ToggleGroupItem } from '../ui/toggle-group';

type IProps = React.ComponentProps<typeof ToggleGroup>;

const WeekToggle: React.FC<IProps> = (props) => (
  <ToggleGroup size="sm" {...props}>
    <ToggleGroupItem value="sun" aria-label="Toggle Dom">
      Dom
    </ToggleGroupItem>
    <ToggleGroupItem value="mon" aria-label="Toggle Seg">
      Seg
    </ToggleGroupItem>
    <ToggleGroupItem value="tue" aria-label="Toggle Ter">
      Ter
    </ToggleGroupItem>
    <ToggleGroupItem value="wed" aria-label="Toggle Qua">
      Qua
    </ToggleGroupItem>
    <ToggleGroupItem value="thu" aria-label="Toggle Qui">
      Qui
    </ToggleGroupItem>
    <ToggleGroupItem value="fri" aria-label="Toggle Sex">
      Sex
    </ToggleGroupItem>
    <ToggleGroupItem value="sat" aria-label="Toggle Sab">
      Sab
    </ToggleGroupItem>
  </ToggleGroup>
);

export default WeekToggle;
